<template>
  <div class="sidebar" :class="size" ref="body" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
    <div v-if="isMobile" class="swipe-icon" @touchstart="handleTouchStart">
      <n-icon icon="minus" />
    </div>
    <header v-if="title">
      <NTitleBar
        :back-button="titleVariant === 'center'"
        v-bind="{ closable, showMenu, title: titleVariant === 'center' ? '' : title, backButtonLabel }"
        @back="$emit('back')"
        @close="$emit('close')"
        @openMenu="$emit('openMenu', $event)"
      />
      <div class="title-variant-center" v-if="titleVariant === 'center'">{{ title }}</div>
    </header>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import NTitleBar from '@/modules/global/components/core/NTitleBar.vue'
import { isMobile } from '@/util/dom-utils'

@Component({
  name: 'NSidebar',
  components: {
    NTitleBar
  }
})
export default class NSidebarContent extends Vue {
  @Prop({ default: true, type: Boolean }) closable!: boolean
  @Prop({ default: false, type: Boolean }) showMenu!: boolean
  @Prop() showBackButton!: boolean
  @Prop({ default: undefined }) backButtonLabel!: string
  @Prop({ default: '' }) title!: string
  @Prop({
    type: String,
    validator: (prop: string) => ['m', 'l'].includes(prop),
    default: 'm'
  })
  size?: String

  @Ref('body') bodyRef!: HTMLElement

  private get titleVariant(): 'left' | 'center' {
    if (this.showBackButton) {
      return 'center'
    }

    return 'left'
  }

  get isMobile() {
    return isMobile()
  }

  handleTouchStart(event: TouchEvent) {
    this.$emit('touchstart', event)
  }

  handleTouchMove(event: TouchEvent) {
    this.$emit('touchmove', event)
  }

  handleTouchEnd(event: TouchEvent) {
    this.$emit('touchend', event)
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.sidebar {
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;

  &.m {
    width: $notch-space-100x;

    @include mobile {
      width: 100%;
    }

    @include tablet {
      width: 70%;
    }
  }

  &.l {
    width: $notch-space-220x;

    @include mobile {
      width: 100%;
    }

    @include tablet {
      width: 70%;
    }
  }
}

header {
  padding: $notch-space-8x $notch-space-8x 0;
  .title-variant-center {
    @include notch-text-heading-semibold-L;
  }
}

.swipe-icon {
  margin-left: $notch-space-6x;
  margin-right: $notch-space-6x + $notch-space-3x;
  min-height: $notch-space-6x;
  display: flex;
  justify-content: center;
}
</style>
